import React from 'react';
import {
    StyledMoreWrapper,
    StyledList,
    StyledBlock,
    StyledListItem,
    StyledButton
} from './GetMoreSection.styles';
import { Heading3 } from '@blueprint/heading';
import { HowMuchIsMyHomeWorthSection } from './HowMuchIsMyHomeWorthSection';

function GetMoreSection() {
    return (
        <StyledMoreWrapper>
            <StyledList>
                <StyledListItem>
                    <HowMuchIsMyHomeWorthSection />
                </StyledListItem>

                <StyledListItem>
                    <StyledBlock color="neutral-2">
                        <Heading3 size="6">Get closer to what matters</Heading3>
                        <StyledButton
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="travel time search"
                            href="/travel-time/"
                        >
                            Search homes by travel time
                        </StyledButton>
                    </StyledBlock>
                </StyledListItem>
                <StyledListItem>
                    <StyledBlock color="tone-brown-t4">
                        <Heading3 size="6">Find an agent</Heading3>
                        <StyledButton
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="find an agent"
                            href="/find-agents/"
                        >
                            Look for local agents
                        </StyledButton>
                    </StyledBlock>
                </StyledListItem>
            </StyledList>
        </StyledMoreWrapper>
    );
}

export default GetMoreSection;
